import React from "react";
import "../styles/Footer.css";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

const Footer = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const content = {
    about: {
      english: "Dedicated to the service of the nation and the welfare of the people. Working towards a strong, prosperous, and self-reliant India.",
      tamil: "தேச சேவைக்கும் மக்கள் நலனுக்கும் அர்ப்பணிக்கப்பட்டது. வலுவான, வளமான மற்றும் சுயாதீன இந்தியாவை நோக்கி பணியாற்றுகிறோம்."
    },
    quickLinks: {
      english: "Quick Links",
      tamil: "விரைவு இணைப்புகள்"
    },
    home: {
      english: "Home ",
      tamil: "முகப்பு"
    },
    missionVision: {
      english: "Mission & Vision",
      tamil: "குறிக்கோள் & பார்வை"
    },
    aboutUs: {
      english: "About Us",
      tamil: "எங்களை பற்றி"
    },
    events: {
      english: "Events Gallery",
      tamil: "நிகழ்வுகள் தொகுப்பு"
    },
    contactUs: {
      english: "Contact Us",
      tamil: "தொடர்பு கொள்ளுங்கள்"
    },
    contactTitle: {
      english: "Contact Us",
      tamil: "தொடர்பு கொள்ளுங்கள்"
    },
    address: {
      english: "Pin - 637502",
      tamil: "அஞ்சல் குறியீடு - 637502"
    }
  };

  return (
    <footer className="footer">
      {/* LEFT - ABOUT */}
      <div className="footer-col footer-about">
        <div className="footer-brand">
          <img src="/assets/sudha-bjp/bjp.png" alt="BJP Logo" />
          <div className="footer-brand1">
            <h2>BJP</h2>
            <p>Bharatiya Janata Party</p>
          </div>
        </div>

        <p className="footer-text">
          {content.about[language]}
        </p>

        <div className="footer-social">
          <img src="/assets/sudha-bjp/fb.png" alt="Facebook" />
          <img src="/assets/sudha-bjp/ig.png" alt="Instagram" />
          <img src="/assets/sudha-bjp/tt.png" alt="Twitter" />
          <img src="/assets/sudha-bjp/yt.png" alt="YouTube" />
        </div>
      </div>

      {/* MIDDLE - QUICK LINKS */}
      <div className="footer-col">
        <h3 className="footer-title">{content.quickLinks[language]}</h3>
        <ul className="footer-links">
          <li onClick={() => navigate("/")}>
            {content.home[language]} &#8599;
          </li>
          <li onClick={() => navigate("/Mission-vission")}>
            {content.missionVision[language]} &#8599;
          </li>
          <li onClick={() => navigate("/Events-gallery")}>
            {content.events[language]} &#8599;
          </li>
          <li onClick={() => navigate("/About")}>
            {content.aboutUs[language]} &#8599;
          </li>
          <li onClick={() => navigate("/Contact")}>
            {content.contactUs[language]} &#8599;
          </li>
        </ul>
      </div>

      {/* RIGHT - CONTACT */}
      <div className="footer-col">
        <h3 className="footer-title">{content.contactTitle[language]}</h3>

        <div className="footer-contact">
          <img src="/assets/loc.png" alt="Location" />
          <p>{content.address[language]}</p>
        </div>

        <div className="footer-contact">
          <img src="/assets/ph.png" alt="Phone" />
          <p>9176995369<br />9894081162</p>
        </div>

        <div className="footer-contact">
          <img src="/assets/ma.png" alt="Email" />
          <p>bjpsudharadhakrishnan <br /> 2025@gmail.com</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;